import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { environment } from '../../../environments/environment';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { UserRoleEnum } from '../../enums/user-role-enum';

@Component({
  selector: 'auth-layout',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.css',
})
export class AuthLayoutComponent implements OnInit {
  constructor(private router: Router, private authService: AuthService) {}
  ngOnInit() {
    this.redirectToHomePageIfAlreadyLoggedIn();
  }
  redirectToHomePageIfAlreadyLoggedIn() {
    if (
      this.authService.CurrentUserValue &&
      this.authService.CurrentUserValue.id
    ) {
      let url =
        this.authService.CurrentUserValue.role == UserRoleEnum.MasterAdmin
          ? environment.DefaultRetrunUrlForMasterAdmin
          : environment.DefaultReturnUrl;
      this.router.navigateByUrl(url);
    }
  }
}
